import { render, staticRenderFns } from "./TekaComponent.vue?vue&type=template&id=3d02c2cc&xmlns=true&"
import script from "./TekaComponent.vue?vue&type=script&lang=js&"
export * from "./TekaComponent.vue?vue&type=script&lang=js&"
import style0 from "./TekaComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d02c2cc')) {
      api.createRecord('3d02c2cc', component.options)
    } else {
      api.reload('3d02c2cc', component.options)
    }
    module.hot.accept("./TekaComponent.vue?vue&type=template&id=3d02c2cc&xmlns=true&", function () {
      api.rerender('3d02c2cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-attraction/basic-data/forms/teka/TekaComponent.vue"
export default component.exports